import { useMatch } from 'react-router-dom';
import { cn } from 'utils/cn';
import { t } from 'utils/getTranslations';

const LINK_CLASS = 'text-fg hover:text-link hover:underline';

const Footer = () => {
    // The audit trail lays its page on the app background, and the footer under it follows suit.
    const onAuditTrail = useMatch('/audit-trail') !== null;
    const onAdminAuditTrail = useMatch('/admin/audit-trail') !== null;
    const isOnAppBackground = onAuditTrail || onAdminAuditTrail;

    return (
        <footer
            className={cn(
                'text-caption mt-auto flex items-center justify-between px-4 pt-6',
                isOnAppBackground && 'bg-bg'
            )}
        >
            <span>&copy; {t('footer.all-rights-reserved')}</span>
            <div className="flex flex-1 items-center justify-end gap-3">
                <a href="https://crespect.com/" target="_blank" rel="noreferrer" className={LINK_CLASS}>
                    {t('footer.about-us')}
                </a>
                <a
                    href="https://crespect.com/home/privacy-policy/"
                    target="_blank"
                    rel="noreferrer"
                    className={LINK_CLASS}
                >
                    {t('footer.privacy-policy')}
                </a>
            </div>
        </footer>
    );
};

export default Footer;
